/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var skipMethods = {
  constructor: 1,
  render: 1,
  shouldComponentUpdate: 1,
  componentWillMount: 1,
  componentDidMount: 1,
  componentWillReceiveProps: 1,
  componentWillUpdate: 1,
  componentDidUpdate: 1,
  componentWillUnmount: 1
};
function autoBind(object, filter) {
  var proto = object.constructor.prototype;
  var filterFn = typeof filter == 'function' ? filter : filter && (0, _typeof2.default)(filter) == 'object' ? function (key) {
    return !filter[key] && skipMethods[key] !== 1 && typeof proto[key] === 'function';
  } : function (key) {
    return skipMethods[key] !== 1 && typeof proto[key] === 'function';
  };
  var names = Object.getOwnPropertyNames(proto).filter(filterFn);
  names.push('setState');
  names.forEach(function (key) {
    object[key] = object[key].bind(object);
  });
  return object;
}
var _default = autoBind;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/react-class/autoBind.js
// module id = 52
// module chunks = 0